/**
 * WHERE MY DAY LIVES. M12 / S12-01.
 *
 * **Project-independent on purpose**, exactly like Settings and Global Sol: a
 * follow-up may point at a Project, but the list of what Brandon has to do is
 * not a property of any one job.
 */
export const MY_DAY_PATH = '/my-day';

/**
 * History lives UNDER My Day — WD-1 (0030). Back from here is My Day, which
 * is the screen its one entry point sits on.
 */
export const MY_DAY_HISTORY_PATH = '/my-day/history';
